export default __webpack_public_path__ + "static/media/rent-benefits-img4.0f91c461.jpg";